"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
/**
 * Computes the total outstanding_balance for a company by summing distinct
 * (program, outstanding_balance) pairs. A company can have multiple programs
 * each with a different outstanding_balance value.
 */
const getCompanyOutstandingBalances = (receivables) => {
    const companyProgramBalances = new Map();
    for (const rec of receivables) {
        const companyId = rec.baseFields.company_id;
        (0, common_1.finleyAssert)(typeof companyId === 'string' && companyId.length > 0, `flexVpc1: baseFields.company_id must be a non-empty string`);
        const program = rec.baseFields.program;
        (0, common_1.finleyAssert)(typeof program === 'string' && program.length > 0, `flexVpc1: baseFields.program must be a non-empty string for company_id=${companyId}`);
        const outstandingBalance = rec.baseFields.outstanding_balance;
        (0, common_1.finleyAssert)(typeof outstandingBalance === 'number', `flexVpc1: baseFields.outstanding_balance must be a number for company_id=${companyId}`);
        if (!companyProgramBalances.has(companyId)) {
            companyProgramBalances.set(companyId, new Map());
        }
        const programMap = companyProgramBalances.get(companyId);
        programMap.set(program, outstandingBalance);
    }
    const companyTotals = new Map();
    for (const [companyId, programMap] of companyProgramBalances) {
        let total = 0;
        for (const balance of programMap.values()) {
            total += balance;
        }
        companyTotals.set(companyId, total);
    }
    return companyTotals;
};
/**
 * Calculates concentration kickouts using outstanding_balance as the measure,
 * distributing kickouts pro-rata by eligible exposure within the breaching group.
 */
const calculateOutstandingBalanceKickouts = ({ breachingReceivables, excessAmount, }) => {
    const totalEligibleExposure = _.sumBy(breachingReceivables, (rec) => rec.concentrationLimitFields
        .eligibleExposureLessConcentrationLimitKickouts);
    if (totalEligibleExposure <= 0) {
        return {};
    }
    const kickouts = {};
    for (const rec of breachingReceivables) {
        const share = common_1.utils.divideByOrZero(rec.concentrationLimitFields
            .eligibleExposureLessConcentrationLimitKickouts, totalEligibleExposure);
        const kickout = share * excessAmount;
        if (kickout > 0) {
            kickouts[rec.finleyReceivableId] = _.round(kickout, 10);
        }
    }
    return kickouts;
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'flexVpc1.threePlusDaysPastDue',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
            'baseFields.total_delinquent_amount',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.threePlusDaysPastDue: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const denominator = _.sum([...companyTotals.values()]);
            const delinquentCompanies = new Set();
            for (const rec of concentrationReceivables) {
                const delinquentAmount = rec.baseFields.total_delinquent_amount;
                if (typeof delinquentAmount === 'number' && delinquentAmount > 0) {
                    delinquentCompanies.add(rec.baseFields.company_id);
                }
            }
            let concentrationAmount = 0;
            for (const companyId of delinquentCompanies) {
                concentrationAmount += companyTotals.get(companyId) || 0;
            }
            const normalizedLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
                concentrationLimit,
                concentrationLimitValueType: valueConfig.valueType,
                totalConcentrationExposure: denominator,
            });
            const exposureLimit = _.round(denominator * normalizedLimit, 10);
            const excessAmount = Math.max(concentrationAmount - exposureLimit, 0);
            let kickouts = {};
            if (excessAmount > 0) {
                const breachingReceivables = concentrationReceivables.filter((rec) => delinquentCompanies.has(rec.baseFields.company_id));
                kickouts = calculateOutstandingBalanceKickouts({
                    breachingReceivables,
                    excessAmount,
                });
            }
            return {
                kickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: normalizedLimit,
                    concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, denominator), 10),
                },
            };
        },
    },
    {
        method: 'flexVpc1.singleObligor',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.singleObligor: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const denominator = _.sum([...companyTotals.values()]);
            const normalizedLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
                concentrationLimit,
                concentrationLimitValueType: valueConfig.valueType,
                totalConcentrationExposure: denominator,
            });
            const exposureLimit = _.round(denominator * normalizedLimit, 10);
            const allKickouts = {};
            let maxConcentrationAmount = 0;
            for (const [companyId, companyBalance] of companyTotals) {
                const excessAmount = Math.max(companyBalance - exposureLimit, 0);
                if (excessAmount > 0) {
                    if (companyBalance > maxConcentrationAmount) {
                        maxConcentrationAmount = companyBalance;
                    }
                    const companyReceivables = concentrationReceivables.filter((rec) => rec.baseFields.company_id === companyId);
                    const kickouts = calculateOutstandingBalanceKickouts({
                        breachingReceivables: companyReceivables,
                        excessAmount,
                    });
                    for (const [id, amount] of Object.entries(kickouts)) {
                        allKickouts[id] = (allKickouts[id] || 0) + amount;
                    }
                }
            }
            return {
                kickouts: allKickouts,
                calculations: {
                    concentrationAmount: maxConcentrationAmount,
                    concentrationLimit: normalizedLimit,
                    concentration: _.round(common_1.utils.divideByOrZero(maxConcentrationAmount, denominator), 10),
                },
            };
        },
    },
    {
        method: 'flexVpc1.topFiveObligors',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.topFiveObligors: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const denominator = _.sum([...companyTotals.values()]);
            const normalizedLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
                concentrationLimit,
                concentrationLimitValueType: valueConfig.valueType,
                totalConcentrationExposure: denominator,
            });
            const sortedCompanies = [...companyTotals.entries()].sort((a, b) => b[1] - a[1]);
            const topFive = sortedCompanies.slice(0, 5);
            const concentrationAmount = _.sumBy(topFive, ([, balance]) => balance);
            const exposureLimit = _.round(denominator * normalizedLimit, 10);
            const excessAmount = Math.max(concentrationAmount - exposureLimit, 0);
            let kickouts = {};
            if (excessAmount > 0) {
                const topFiveCompanyIds = new Set(topFive.map(([id]) => id));
                const breachingReceivables = concentrationReceivables.filter((rec) => topFiveCompanyIds.has(rec.baseFields.company_id));
                kickouts = calculateOutstandingBalanceKickouts({
                    breachingReceivables,
                    excessAmount,
                });
            }
            return {
                kickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: normalizedLimit,
                    concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, denominator), 10),
                },
            };
        },
    },
    {
        method: 'flexVpc1.singleIndustry',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
            'baseFields.industry',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.singleIndustry: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const denominator = _.sum([...companyTotals.values()]);
            const normalizedLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
                concentrationLimit,
                concentrationLimitValueType: valueConfig.valueType,
                totalConcentrationExposure: denominator,
            });
            const companyIndustry = new Map();
            for (const rec of concentrationReceivables) {
                const companyId = rec.baseFields.company_id;
                const industry = rec.baseFields.industry;
                (0, common_1.finleyAssert)(typeof industry === 'string', `flexVpc1.singleIndustry: baseFields.industry must be a string for company_id=${companyId}`);
                companyIndustry.set(companyId, industry);
            }
            const industryTotals = new Map();
            for (const [companyId, balance] of companyTotals) {
                const industry = companyIndustry.get(companyId);
                industryTotals.set(industry, (industryTotals.get(industry) || 0) + balance);
            }
            const exposureLimit = _.round(denominator * normalizedLimit, 10);
            const allKickouts = {};
            let maxConcentrationAmount = 0;
            for (const [industry, industryBalance] of industryTotals) {
                const excessAmount = Math.max(industryBalance - exposureLimit, 0);
                if (excessAmount > 0) {
                    if (industryBalance > maxConcentrationAmount) {
                        maxConcentrationAmount = industryBalance;
                    }
                    const industryCompanies = new Set([...companyIndustry.entries()]
                        .filter(([, ind]) => ind === industry)
                        .map(([id]) => id));
                    const breachingReceivables = concentrationReceivables.filter((rec) => industryCompanies.has(rec.baseFields.company_id));
                    const kickouts = calculateOutstandingBalanceKickouts({
                        breachingReceivables,
                        excessAmount,
                    });
                    for (const [id, amount] of Object.entries(kickouts)) {
                        allKickouts[id] = (allKickouts[id] || 0) + amount;
                    }
                }
            }
            return {
                kickouts: allKickouts,
                calculations: {
                    concentrationAmount: maxConcentrationAmount,
                    concentrationLimit: normalizedLimit,
                    concentration: _.round(common_1.utils.divideByOrZero(maxConcentrationAmount, denominator), 10),
                },
            };
        },
    },
    {
        method: 'flexVpc1.weightedAvgFico',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
            'baseFields.fico',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.weightedAvgFico: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const companyFico = new Map();
            for (const rec of concentrationReceivables) {
                const companyId = rec.baseFields.company_id;
                if (!companyFico.has(companyId)) {
                    const fico = rec.baseFields.fico;
                    (0, common_1.finleyAssert)(typeof fico === 'number', `flexVpc1.weightedAvgFico: baseFields.fico must be a number for company_id=${companyId}`);
                    companyFico.set(companyId, fico);
                }
            }
            const weightedAverageReceivables = [];
            for (const rec of concentrationReceivables) {
                const companyId = rec.baseFields.company_id;
                const companyBalance = companyTotals.get(companyId) || 0;
                const fico = companyFico.get(companyId) || 0;
                weightedAverageReceivables.push({
                    finleyReceivableId: rec.finleyReceivableId,
                    eligibleExposureLessConcentrationLimitKickouts: rec.concentrationLimitFields
                        .eligibleExposureLessConcentrationLimitKickouts,
                    weight: companyBalance,
                    value: fico,
                });
            }
            return (0, calc_agent_1.calculateWeightedAverageReceivableKickouts)({
                receivables: weightedAverageReceivables,
                concentrationLimit,
                limitType: 'min',
                waConcentrationLimitSolver: 'greedy',
            });
        },
    },
    {
        method: 'flexVpc1.withoutPersonalGuarantee',
        requiredFields: [
            'baseFields.company_id',
            'baseFields.program',
            'baseFields.outstanding_balance',
            'baseFields.signed_pg',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `flexVpc1.withoutPersonalGuarantee: unsupported valueConfig.type=${valueConfig.type}`);
            const concentrationLimit = valueConfig.limit;
            const companyTotals = getCompanyOutstandingBalances(concentrationReceivables);
            const denominator = _.sum([...companyTotals.values()]);
            const normalizedLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
                concentrationLimit,
                concentrationLimitValueType: valueConfig.valueType,
                totalConcentrationExposure: denominator,
            });
            const unsignedPgCompanies = new Set();
            for (const rec of concentrationReceivables) {
                const companyId = rec.baseFields.company_id;
                if (rec.baseFields.signed_pg === 'false') {
                    unsignedPgCompanies.add(companyId);
                }
            }
            let concentrationAmount = 0;
            for (const companyId of unsignedPgCompanies) {
                concentrationAmount += companyTotals.get(companyId) || 0;
            }
            const exposureLimit = _.round(denominator * normalizedLimit, 10);
            const excessAmount = Math.max(concentrationAmount - exposureLimit, 0);
            let kickouts = {};
            if (excessAmount > 0) {
                const breachingReceivables = concentrationReceivables.filter((rec) => unsignedPgCompanies.has(rec.baseFields.company_id));
                kickouts = calculateOutstandingBalanceKickouts({
                    breachingReceivables,
                    excessAmount,
                });
            }
            return {
                kickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: normalizedLimit,
                    concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, denominator), 10),
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map